import { api } from '@marketplace-web/core-api/core-api-client-data'

import { ProfileUserInfoResp } from '../types/dtos/profile-user-info-resp'
import { GetUserItemFacetsArgs, ItemFacetsResp } from '../types/dtos/item-facets'
import { GetSellerFiltersResp } from '../types/dtos/seller-filters'

import { GetWardrobeCatalogsResp } from '../types/dtos/get-wardrobe-catalogs-resp'
import { GetWardrobeItemsArgs, GetWardrobeItemsResp } from '../types/wardrobe-item'
import { getWardrobeItemsArgsToParams } from '../transformers/wardrobe-item'

import { UserBlockArgs, UserResp } from '../types/user'

const moneyObjectHeader = {
  'X-Money-Object': 'true',
}

export const getWardrobeCatalogs = () => api.get<GetWardrobeCatalogsResp>('/wardrobe/catalogs')

export const getProfileUserInfo = (userId: number) =>
  api.get<ProfileUserInfoResp>(`users/${userId}/profile`)

export const getSellerFilters = () => api.get<GetSellerFiltersResp>('/closet/seller_filters')

export const getUserItemFacets = ({ userId }: GetUserItemFacetsArgs) =>
  api.get<ItemFacetsResp>(`/users/${userId}/item_facets`)

export const getWardrobeItems = (args: GetWardrobeItemsArgs) =>
  api.get<GetWardrobeItemsResp>(`/wardrobe/${args.userId}/items`, {
    params: getWardrobeItemsArgsToParams(args),
    headers: moneyObjectHeader,
  })

export const blockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.post(`/users/${currentUserId}/user_hates`, { hated_user_id: blockedUserId })

type GetUserByIdArgs = {
  id: number
  localize?: boolean
}

export const getUserById = ({ id, localize = false }: GetUserByIdArgs) =>
  api.get<UserResp>(`/users/${id}`, { params: { localize } })

export const unblockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.delete(`/users/${currentUserId}/user_hates`, { params: { hated_user_id: blockedUserId } })
